import {createAsyncThunk, createSelector, createSlice} from '@reduxjs/toolkit';
import {UserContextProps} from "./types.ts";
import {processUserLogin} from "@/redux/apis/api";
import axios from "axios";
import {USER_DETAILS} from "@/redux/rtk/admin/users/type";

const name = "USERS";

interface INITIAL_STATE {
    userContext: UserContextProps | null;
    userDetails: USER_DETAILS | null
}

const initialState: INITIAL_STATE = {
    userContext: null,
    userDetails: null
}

export const userActions = {
    processUserLogin: createAsyncThunk(`${name}/getUserContext`, async (data: any, { rejectWithValue }) => {
        try {
            return await processUserLogin(data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(error.response?.data || "An unknown error occurred"); // Return server error response
            }
            return rejectWithValue("Something went wrong"); // Generic error
        }
    }),
}

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        updateUserContext: (state, { payload }) => {
            state.userContext = payload;
        },
        updateUserDetails: (state, { payload }: {payload: USER_DETAILS}) => {
            state.userDetails = payload;
        },
        resetUserDetails: (state, { payload }) => {
            state.userDetails = null
        },
    },
    extraReducers: (builder) => {

    }
});

export const usersSelectors = {
    getUserContext: createSelector(
        (state) => {
            return state.users.userContext;
        },
        (userContext) => userContext,
    ),
    getUserDetails: createSelector(
        (state) => {
            return state.users.userDetails;
        },
        (userDetails) => userDetails,
    ),
}

const { reducer, actions } = usersSlice;
export const { updateUserDetails, updateUserContext } = actions;
export default reducer;